/**
 * Tiếng Việt locale. Phonetic coverage targets Vietnamese tones.
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business ベトナム語 UI 文言と読み上げスクリプト 3 文の locale bundle
 * @graph-connects none
 */

import type { LocaleBundle } from './types.js';

/** @graph-connects none */
export const vi: LocaleBundle = {
  messages: {
    appTitle: 'Đăng ký giọng nói',
    consent: {
      title: 'Đồng ý',
      summary:
        'Việc đăng ký giọng nói giúp nhận diện người phát biểu chính xác hơn trong các buổi họp Meet. Vui lòng đọc kỹ trước khi tiếp tục.',
      items: [
        'Bản ghi âm chỉ được dùng để tính đặc trưng giọng nói (embedding).',
        'Bản ghi gốc được tự động xóa khỏi GCS sau 30 ngày. Đặc trưng giọng nói được lưu lại cho đến khi bạn yêu cầu xóa.',
        'Bạn có thể yêu cầu xóa dữ liệu giọng nói bất kỳ lúc nào.',
        'Dữ liệu chỉ được dùng nội bộ — chỉ pipeline nhận diện giọng nói nội bộ truy cập.',
      ],
      agreeLabel: 'Đồng ý và tiếp tục',
      declineLabel: 'Hủy',
    },
    languageSelect: {
      title: 'Chọn ngôn ngữ',
      description:
        'Hệ thống đăng ký một đặc trưng giọng nói cho mỗi ngôn ngữ chính. Bạn có thể quay lại sau để bổ sung ngôn ngữ khác.',
      languageNames: {
        ja: '日本語',
        en: 'English',
        vi: 'Tiếng Việt',
      },
      confirm: 'Tiếp theo',
    },
    recording: {
      title: 'Ghi âm đọc',
      instruction:
        'Hãy đọc câu hiển thị bằng giọng nói tự nhiên. Vui lòng ngồi ở nơi yên tĩnh và cách micro khoảng 30 cm.',
      progressLabel: 'Đang ghi âm…',
      startLabel: 'Bắt đầu ghi âm',
      stopLabel: 'Dừng ghi âm',
      retakeLabel: 'Ghi lại',
      nextLabel: 'Câu tiếp theo',
      submitLabel: 'Đăng ký',
      qualityIssue: 'Phát hiện vấn đề về chất lượng âm thanh',
      qualityHint: 'Bản ghi có thể quá ngắn, quá nhỏ hoặc có nhiều khoảng lặng. Vui lòng thử lại.',
      recordHint: 'Nhấn để ghi âm',
      checkHint: 'Nhấn để kiểm tra',
      readyHint: '✓ Sẵn sàng',
      retryHint: '⚠ Thử lại',
    },
    result: {
      successTitle: 'Đăng ký hoàn tất',
      successDescription:
        'Từ giờ phát biểu của bạn trong các bản ghi Meet sẽ được gán đúng tên của bạn.',
      failureTitle: 'Đăng ký thất bại',
      failureDescription:
        'Đã xảy ra lỗi máy chủ. Vui lòng thử lại sau ít phút. Liên hệ quản trị viên nếu vẫn tiếp tục lỗi.',
      backLabel: 'Bắt đầu lại',
    },
  },
  readingScripts: [
    {
      id: 'vi-1',
      text: 'Cuối tuần tôi thường dậy sớm, pha một ly cà phê sữa đá thật đậm, rồi ngồi đọc sách bên cửa sổ ngắm phố phường buổi sáng.',
      estimatedSeconds: 11,
    },
    {
      id: 'vi-2',
      text: 'Tôi yêu phở bò gân, bún chả Hà Nội, và bánh mì giòn rụm với pa-tê. Mỗi món ăn là một mảnh ký ức của Việt Nam.',
      estimatedSeconds: 11,
    },
    {
      id: 'vi-3',
      text: 'Mùa thu Hà Nội có hương cốm xanh, tiếng lá vàng rơi xào xạc, và những chiếc áo len màu nâu nhạt được lấy ra khỏi tủ sau nửa năm.',
      estimatedSeconds: 12,
    },
  ],
};
